<template>
  <v-dialog v-model="dialog" max-width="510">
    <v-card>
      <v-card-title class="text-h3">
        {{ $t('STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TITLE') }}
      </v-card-title>

      <v-card-text class="text-body-2">
        {{ $t('STEPPER_EDIT_VALIDATED_OFFER_DIALOG_TEXT') }}
      </v-card-text>

      <v-card-actions class="pb-4 pr-8">
        <v-spacer />

        <v-btn
          class="link non-text-transformation"
          color="black"
          outlined
          tile
          @click="handleCancel"
        >
          {{ $t('STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CANCEL') }}
        </v-btn>

        <v-btn class="link non-text-transformation" color="primary" tile @click="handleConfirm">
          {{ $t('STEPPER_EDIT_VALIDATED_OFFER_DIALOG_BUTTON_CONFIRM') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditValidatedOfferDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.show
      },
      set() {
        // HACK: avoid component directly mutating prop `show` on click outside
        this.handleCancel()
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit('cancelEditValidatedOffer')
    },
    handleConfirm() {
      this.$emit('confirmEditValidatedOffer')
    },
  },
}
</script>
